<div class="mat-elevation-z3" [style]="gridStyle">

  <app-portal-template-timetype-selector #portalTemplateSelector class="timetype-selector" (portalTemplateValueChanged)="onPortalTemplateValueChanged($event)"></app-portal-template-timetype-selector>

  <app-project-portal-employee-selector *ngIf="employeeSelectorVisible" #projectPortalEmployeeSelector class="employee-selector" (employeeValueChanged)="onProjectPortalEmployeeValueChanged($event)"></app-project-portal-employee-selector>

  <dx-data-grid #datagriddx class="time-grid pointer time-grid-position"
                [dataSource]="dataSource"
                [columns]="columns"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                (onEditorPreparing)="onEditorPreparing($event)"
                (onEditingStart)="onEditingStart($event)"
                (onSaving)="onSavingMultiple($event)"
                (onInitNewRow)="onInitNewRow($event)"
                (onCellPrepared)="onCellPrepared($event)"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="onSelectionChanged($event)">

    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-editing [mode]="editMode" [allowUpdating]="allowAddingAndUpdate()" [allowAdding]="allowAddingAndUpdate()" [useIcons]="true"></dxo-editing>
    <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
    <dxo-paging [pageSize]="500"></dxo-paging>
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
    <dxo-export [enabled]="true"></dxo-export>

    <div *dxTemplate="let c of 'cellTemplateStatus'">
      <span class="status-letter">{{getFirstLetterOfStatus(c.data)}}</span>
    </div>

    <div *dxTemplate="let data of 'dateGroupTemplate'">
      <span>{{groupTemplate(data)}}</span>
    </div>

    <div *dxTemplate="let cellInfo of 'employeeEditTemplate'">
      <span style="padding-left: 7px" *ngIf="!allowRowUpdating(cellInfo.data.StatusId, cellInfo.data.CategoryId); else edit_employee_select">{{cellInfo.data.EmployeeName}}</span>
      <ng-template #edit_employee_select>
        <dx-select-box [dataSource]="{store: !employeeSelectorVisible ? employees : supervisorEmployees, paginate: true, pageSize: 10}"
                       displayExpr="EmployeeNumberAndName"
                       searchExpr="EmployeeNumberAndName"
                       valueExpr="EmployeeId"
                       (onValueChanged)="onEmployeeValueChanged($event, cellInfo)"
                       [searchEnabled]="true"
                       [height]="35"
                       [showClearButton]="true"
                       [value]="cellInfo.data.EmployeeId">
        </dx-select-box>
      </ng-template>
    </div>

    <div *dxTemplate="let cellInfo of 'projectEditTemplate'">
      <span style="padding-left: 7px" *ngIf="(!allowRowUpdating(cellInfo.data.StatusId, cellInfo.data.CategoryId) || cellInfo.data.CategoryId == 8); else edit_project_select">{{cellInfo.data.Project}}</span>
      <ng-template #edit_project_select>
        <dx-box direction="row"
                width="100%">
          <dxi-item [ratio]="9">
            <dx-select-box [dataSource]="projectsDataSource"
                           displayExpr="ProjectDisplayName"
                           searchExpr="ProjectDisplayName"
                           valueExpr="ProjectId"
                           (onValueChanged)="onProjectValueChanged($event, cellInfo)"
                           [searchEnabled]="true"
                           [height]="35"
                           [showClearButton]="true"
                           [placeholder]="placeholderProjectSelectSearch"
                           [value]="cellInfo.data.CarrierProjectId"
                           (onFocusIn)="focusProject($event)">
            </dx-select-box>
          </dxi-item>
          <dxi-item [ratio]="1">
            <dx-button style="margin-left: 2px; margin-right: 2px" icon="search" [height]="35" (onClick)="showPopupProject(cellInfo.data.CarrierProjectId, cellInfo.data.CustomerId, cellInfo)"></dx-button>
          </dxi-item>
        </dx-box>
      </ng-template>
    </div>

    <div *dxTemplate="let cellInfo of 'fromProjectEditTemplate'">
      <span style="padding-left: 7px" *ngIf="(!allowRowUpdating(cellInfo.data.StatusId, cellInfo.data.CategoryId) || !cellInfo.data.IsTransport); else edit_from_project_select">{{cellInfo.data.FromProjectNumber}}</span>
      <ng-template #edit_from_project_select>
        <dx-box direction="row" width="100%">
          <dxi-item [ratio]="5">
            <dx-select-box [dataSource]="projectsDataSource"
              displayExpr="ProjectNumber"
              searchExpr="ProjectNumber"
              valueExpr="ProjectNumber"
              [searchEnabled]="true"
              [height]="35"
              [showClearButton]="false"
              [placeholder]="placeholderProjectSelectSearch"
              [value]="cellInfo.data.FromProjectNumber"
              (onValueChanged)="onFromProjectValueChanged($event, cellInfo)">
            </dx-select-box>
          </dxi-item>
        </dx-box>
      </ng-template>
    </div>

    <div *dxTemplate="let cellInfo of 'toProjectEditTemplate'">
      <span style="padding-left: 7px" *ngIf="(!allowRowUpdating(cellInfo.data.StatusId, cellInfo.data.CategoryId) || !cellInfo.data.IsTransport); else edit_to_project_select">{{cellInfo.data.ToProjectNumber}}</span>
      <ng-template #edit_to_project_select>
        <dx-box direction="row" width="100%">
          <dxi-item [ratio]="5">
            <dx-select-box [dataSource]="projectsDataSource"
              displayExpr="ProjectNumber"
              searchExpr="ProjectNumber"
              valueExpr="ProjectNumber"
              [searchEnabled]="true"
              [height]="35"
              [showClearButton]="false"
              [placeholder]="placeholderProjectSelectSearch"
              [value]="cellInfo.data.ToProjectNumber"
              (onValueChanged)="onToProjectValueChanged($event, cellInfo)">
            </dx-select-box>
          </dxi-item>
        </dx-box>
      </ng-template>
    </div>

    <div *dxTemplate="let cellInfo of 'projectActivityEditTemplate'">
      <span style="padding-left: 7px" *ngIf="!allowRowUpdating(cellInfo.data.StatusId, cellInfo.data.CategoryId); else edit_projectactivity_select">{{cellInfo.data.Activity}}</span>
      <ng-template #edit_projectactivity_select>
        <dx-select-box [dataSource]="projectActivitiesByProjectType"
                       displayExpr="ProjectNumberAndName"
                       searchExpr="ProjectNumberAndName"
                       valueExpr="ProjectId"
                       (onValueChanged)="onProjectActivityValueChanged($event, cellInfo)"
                       [searchEnabled]="true"
                       [height]="35"
                       [readOnly]="readonlyProjectActivity"
                       [showClearButton]="true"
                       [value]="cellInfo.data.ProjectId"
                       (onFocusIn)="focusProjectActivity($event, cellInfo)">
        </dx-select-box>
      </ng-template>
    </div>

    <div *dxTemplate="let data of 'copyCellTemplate'">
      <a text="{{languageService.LNG('Label.Copy')}}" class="dx-link dx-link-copy" (click)="onCopyRow($event, data)">Copy</a>
    </div>

    <div *dxTemplate="let cellInfo of 'cellTemplateFromProject'">
      <span [title]="cellInfo.data.FromProject">{{cellInfo.data.FromProjectNumber}}</span>
    </div>

    <div *dxTemplate="let cellInfo of 'cellTemplateToProject'">
      <span [title]="cellInfo.data.ToProject">{{cellInfo.data.ToProjectNumber}}</span>
    </div>

    <div *dxTemplate="let cellInfo of 'typeCellTemplate'">
      <dx-button *ngIf="cellInfo.data.IsTransport" height="22" class="transport-button" template="transportBtnTemplate" (onClick)="onOpenTransport($event, cellInfo)">
        <div *dxTemplate="let data of 'transportBtnTemplate'">
          <fa-icon size="xs" [icon]="faTruckMoving"></fa-icon>
        </div>
      </dx-button>
      <span *ngIf="cellInfo.data.HasExpense" class="type-icon dx-icon-money"></span>
      <span *ngIf="cellInfo.data.HasAddition" class="type-icon dx-icon-plus font-size"></span>
      <span [title]="cellInfo.data.CustomRef">{{cellInfo.data.CustomRef | slice:0:10}}</span>
    </div>

    <div *dxTemplate="let cellInfo of 'timeCellTemplate'">
      <span>{{cellInfo["data"][cellInfo.column.dataField] | timeFormat}}</span>
    </div>

    <div *dxTemplate="let cellInfo of 'timeEditTemplate'">
      <span *ngIf="!allowRowUpdating(cellInfo.data.StatusId, cellInfo.data.CategoryId); else edit_time">{{cellInfo["data"][cellInfo.column.dataField] | timeFormat}}</span>
      <ng-template #edit_time>
        <app-masked-time-input [(value)]="cellInfo['data'][cellInfo.column.dataField]" (valueChanged)="onTimeValueChanged($event, cellInfo)"></app-masked-time-input>
      </ng-template>      
    </div>

    <div *dxTemplate="let data of 'transportBtnTemplate'">
      <div [style.padding]="'0.16rem 0.1rem'">
        <fa-icon [icon]="faTruckMoving"></fa-icon>
      </div>
    </div>

  </dx-data-grid>
</div>

<dx-popup
  class="popup"
  [width]="500"
  [height]="300"
  [showTitle]="true"
  [title]="languageService.LNG('Label.Project')"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
      <p>
        {{languageService.LNG("Label.Customer")}}:
        <dx-select-box [dataSource]="customerPopupDataSource"
          displayExpr="Name"
          valueExpr="CustomerId"
          [searchEnabled]="true"
          (onValueChanged)="onPopupCustomerChanged($event)"
          [value]="selectedCustomerIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        {{languageService.LNG("Label.Project")}}:
        <dx-select-box [dataSource]="projectsPopupDataSource"
          displayExpr="ProjectDisplayName"
          searchExpr="ProjectDisplayName"
          valueExpr="ProjectId"
          [searchEnabled]="true"
          (onValueChanged)="onPopupProjectChanged($event)"
          [placeholder]="placeholderProjectSelectSearch"
          [value]="selectedProjectIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p class="margin-top">
        <dx-button text="Ok" (onClick)="onClickPopupSelectedProject($event)"></dx-button>
      </p>
  </div>
</dx-popup>

<dx-popup
  class="popup"
  [showTitle]="true"
  [title]="titleEditTransport"
  [dragEnabled]="false"
  [fullScreen]="true"
  [(visible)]="popupEditTransportVisible">
  <div *dxTemplate="let data of 'content'">
      <div *ngIf="popupEditTransportVisible">
        <app-edit-transport #editTransport
          [(transport)]="transport"
          [employees]="employees"
          [projects]="projectsDataSource"
          [newStatusId]="3"
          [newCategoryId]="8"
          (refresh)="onRefresh($event)">
        </app-edit-transport>
      </div>
  </div>
</dx-popup>

<dx-popup class="popup"
  [fullScreen]="true"
  [showTitle]="true"
  [title]="languageService.LNG('Label.QuickEntry')"
  [(visible)]="popupQuickEntryVisible">
  <div *dxTemplate="let data of 'content'">
    <div *ngIf="popupQuickEntryVisible">
      <app-quick-entry
        [employees]="employees"
        [projects]="projectsDataSource"
        (saved)="onQuickEntriesSaved($event)">
      </app-quick-entry>
    </div>
  </div>
</dx-popup>

<app-load-panel *ngIf="isApproving || isResetting"></app-load-panel>
